<template>
  <PageContainer
    tag="nav"
    class="c-breadcrumb"
    aria-label="Breadcrumb"
  >
    <slot />
  </PageContainer>
</template>

<script setup>
import { provide } from 'vue'
import { PageContainer } from '../PageLayout'

const props = defineProps({
  separator: {
    type: String,
    default: ''
  }
})

provide('breadcrumbSeparator', props.separator)
</script>

<style lang="less" scoped>
.c-breadcrumb {
  border-bottom: 0.04167rem solid #e4e6eb;

  :deep(.page-container__content) {
    display: flex;
    align-items: center;
    height: 48px;
  }
}
</style>
